module.exports = __webpack_public_path__ + "static/img/pic-3.9ab8dc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-3.jpg
// module id = uzD7
// module chunks = 1